import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import classNames from 'classnames';
import { SocialButton } from '../SocialButton';
import { SocialExpandButton } from '../SocialExpandButton';
import * as styles from './SocialsWrapper.css';
export var SocialsWrapper = function SocialsWrapper(props) {
  var isExpanded = props.isExpanded,
      onClick = props.onClick,
      list = props.list,
      expand = props.expand,
      error = props.error,
      frameless = props.frameless;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['container'], _defineProperty({}, styles['frameless'], frameless))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['buttons-container']
  }, /*#__PURE__*/React.createElement("ul", {
    className: classNames(styles['buttons'], styles['horizontal-scroll'])
  }, list.map(function (socialType) {
    return /*#__PURE__*/React.createElement("li", {
      key: "social_button-".concat(socialType),
      className: styles['buttons-item']
    }, /*#__PURE__*/React.createElement(SocialButton, {
      type: socialType,
      onClick: onClick
    }));
  }), !isExpanded && /*#__PURE__*/React.createElement("li", {
    className: styles['buttons-item']
  }, /*#__PURE__*/React.createElement(SocialExpandButton, {
    onClick: expand
  })))), error && /*#__PURE__*/React.createElement("div", {
    className: styles['error']
  }, error));
};